import {ApolloLink} from '@apollo/client';
import {Headers} from '@sail/data';
import addHttpHeaders from '../../shared/addHttpHeaders';
import getSchemaVersion from '../../getSchemaVersion';
import addContextHeaders from '../../shared/addContextHeaders';

import type {StripeContextInput as V2ContextInput} from '../../../schema/types';

export default function createHttpHeadersLink(endpoint: string) {
  const schemaVersion = getSchemaVersion();

  return new ApolloLink(function httpHeadersLink(operation, forward) {
    const v2Context = (operation.variables.v2Context || {}) as V2ContextInput;

    operation.setContext(function contextWithHeaders(prevContext: {
      headers: Headers;
    }) {
      const headers = new Headers([
        ...Object.entries(prevContext?.headers ?? {}),
      ]);

      // TODO(MOVE_TO_V2CONTEXTINPUT): This should just be (headers, v2Context).
      addContextHeaders(
        headers,
        {
          apiKey: v2Context.apiKey,
          id: v2Context.id || null,
          liveMode: v2Context.liveMode,
        },
        endpoint,
      );

      addHttpHeaders(headers, schemaVersion, endpoint);

      // TODO: Enforce that operation name is present for all queries.
      if (operation.operationName != null) {
        headers.set('X-Stripe-Graphql-Operation', operation.operationName);
      }

      return {
        ...prevContext,
        headers: headers.getFetchHeaders(),
      };
    });

    return forward(operation);
  });
}
